import Form from "@/views/App/Portal/CaseManagementCoaching/FirstInterview/Form.vue";
import List from "@/views/App/Portal/CaseManagementCoaching/Protocol/List.vue";
import FirstAppointmentList from "@/views/App/Portal/CaseManagementCoaching/InvitationToFirstAppointment/List.vue";
import FinalReportForm from "@/views/App/Portal/CaseManagementCoaching/FinalReport/Form.vue";
import ConfirmationBillingForm from "@/views/App/Portal/CaseManagementCoaching/ConfirmationBilling/Form.vue";
import DocumentsFrom from "@/views/App/Portal/CaseManagementCoaching/Documents/Form.vue";

const routesPortalCaseManagementCoaching = [
    {
        path: 'first-interview/:id',
        name: 'caseManagementCoachingFirstInterviewForm',
        component: Form
    },
    {
        path: 'protocol-list/:id',
        name: 'caseManagementCoachingProtocolList',
        component: List
    },
    {
        path: 'invitation-to-first-appointment-list/:id',
        name: 'caseManagementCoachingInvitationToFirstAppointmentList',
        component: FirstAppointmentList
    },
    {
        path: 'final-report/:id',
        name: 'caseManagementCoachingFinalReportForm',
        component: FinalReportForm
    },
    {
        path: 'confirmation-billing/:id',
        name: 'caseManagementCoachingConfirmationBillingForm',
        component: ConfirmationBillingForm
    },
    {
        path: 'documents/:id',
        name: 'caseManagementCoachingDocumentsForm',
        component: DocumentsFrom
    }
];

export default routesPortalCaseManagementCoaching;